import { UsersWonLotResponse } from '@bonhams1793/bonhams-typescript'

import { createAuthenticatedAxiosClient } from '@nx/axios-client'
import { BonhamsCookies } from '@nx/global-types'

interface GetUsersWonLotsProps {
  baseURL: string
  cookies: BonhamsCookies
}

export async function getUsersWonLots({
  baseURL,
  cookies,
}: GetUsersWonLotsProps) {
  const authenticatedAxiosClient = createAuthenticatedAxiosClient({
    accessTokenSSR: cookies.bonhams_access,
    refreshTokenSSR: cookies.bonhams_token,
    baseURL,
  })

  const url = '/api/clients/purchases/v1/outstanding'

  const response = await authenticatedAxiosClient.get<UsersWonLotResponse>(
    url,
    {
      baseURL,
    }
  )

  return response.data
}
